import { getDateWithSpecificFormat } from '../../../../data-transform';
import { getCountryNameByCountryCode, getStatusDescriptionFromStatusValue, getOrderTypeText } from '../../../../../utils/utility';

export default function myReportsTableColumns(config) {
    let result = {};
    let tableData = [];

    const { reportList = [], selectedOrderId = null } = config.data;

    reportList.map((report, index) => {
        let row = [];
        const rowId = report.orderId;
        config.columns.forEach(column => {

            let columnValue = "";
            let customEventHandler = null;
            const columnDataType = column.data.displayInBodyAs;
            let isDisabled = false;
            let availabilitySufixText = null;
            let applyBgColorForOpenDisputeStatus = false;
            let displayAsIs = column.data.displayInBodyAsIs;

            if (column.data.displayInBodyAs === "string") {
                if (column.id === "orderId") {
                    columnValue = report.orderId || "";
                    displayAsIs = true;
                    applyBgColorForOpenDisputeStatus = report.disputeStatus === 'OPEN' ? true : false;
                }
                else if (column.id === "orderType") {
                    columnValue = getOrderTypeText(report.orderType) || "";
                    displayAsIs = true;
                }
                else if (column.id === "collectionCity") {
                    columnValue = report.collectionCity || "";
                    displayAsIs = true;
                }
                else if (column.id === "collectionDate") {
                    columnValue = getDateWithSpecificFormat(report.collectionDate) || "";
                    displayAsIs = true;
                }
                else if (column.id === "status") {
                    let statusForCustomer;
                    if (report.status === 'ORDER_SENT' || report.status === 'ORDER_RECEIVED') {
                        statusForCustomer = 'ORDER_SUBMITTED';
                    }
                    columnValue = report.status ? getStatusDescriptionFromStatusValue( statusForCustomer || report.status) : "";
                    displayAsIs = true;
                }
                else if (column.id === "country") {
                    columnValue = getCountryNameByCountryCode(report.countryCode) || "";
                    displayAsIs = true;
                }
                else if (column.id === "legalEntityName") {
                    columnValue = report.legalEntity || "";
                    displayAsIs = true;
                }
                else if (column.id === "company") {
                    columnValue = report.company || "";
                    displayAsIs = true;
                }
            }
            else if (columnDataType === "selectionCheckBox") {
                if (report.reportingStatus === "NOT_AVAILABLE") {
                    isDisabled = true;
                    availabilitySufixText = "Not Available";
                }
                if (report.reportingStatus === "AVAILABLE") {
                    availabilitySufixText = "Available";
                }
                if(report.reportingStatus === "AVAILABLE" && report.ctHpStatus === "CT_PAYMENT_PENDING") {                    
                    availabilitySufixText = "Not Available";
                }

                if (column.id === "auditFinancialReport") {
                    columnValue = report.afReport;
                    if (selectedOrderId) {
                        isDisabled = selectedOrderId === rowId && reportList[index].reportingStatus === "AVAILABLE" ? false : true;
                    }
                    customEventHandler = (config.bodyButtonsHandler && config.bodyButtonsHandler.handleAuditFinancialReportCheckboxSelection) ? event => config.bodyButtonsHandler.handleAuditFinancialReportCheckboxSelection(event, report.orderId) : null
                }
                else if (column.id === "sustainabilityBenefitReport") {
                    columnValue = report.sustainabilityReport;
                    if (selectedOrderId) {
                        isDisabled = selectedOrderId === rowId && reportList[index].reportingStatus === "AVAILABLE" ? false : true;
                    }
                    customEventHandler = (config.bodyButtonsHandler && config.bodyButtonsHandler.handleSustainabilityBenefitReportCheckboxSelection) ? event => config.bodyButtonsHandler.handleSustainabilityBenefitReportCheckboxSelection(event, report.orderId) : null
                }
                else if (column.id === "dataSanitizationReport" || column.id === "certificateOfDataSanitizationReport") {
                    columnValue = report.dataSanitizationReport;
                    if (selectedOrderId) {
                        isDisabled = selectedOrderId === rowId && reportList[index].reportingStatus === "AVAILABLE" ? false : true;
                    }
                    customEventHandler = (config.bodyButtonsHandler && config.bodyButtonsHandler.handleDataSanitizationReportCheckboxSelection) ? event => config.bodyButtonsHandler.handleDataSanitizationReportCheckboxSelection(event, report.orderId) : null
                }
            }

            row.push({
                [column.id]: {
                    columnId: column.id,
                    id: column.id + "|" + rowId,
                    type: column.data.displayInBodyAs,
                    value: columnValue,
                    width: column.width,
                    disabled: isDisabled,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    clickHandler: customEventHandler,
                    availabilitySufixText: availabilitySufixText,
                    yellowBgClass: applyBgColorForOpenDisputeStatus
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });

    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}
